import VideoJsPlayer from 'video.js/dist/types/player';
import { orderRewindsByTime } from './orderRewinds';
import {
  RewindStitcherOptions,
  RewindStitcherVideoJsPlayer,
  RewindVideo,
} from './rewindStitcher.types';
import { attemptToPlayNextRewind, playRewindAtPosition } from './playRewind';

export const rewindController = (player: VideoJsPlayer, options: RewindStitcherOptions) => {
  const { rewinds } = options;
  let { start, end } = options;
  let rewindList: RewindVideo[] = orderRewindsByTime(rewinds);
  let currentRewind: RewindVideo | null = null;
  let currentTimestamp: Date | null = null;

  const setCurrentRewind = (rewindVideo: RewindVideo) => {
    currentRewind = rewindVideo;
  };

  const setCurrentTimestamp = (date: Date) => {
    currentTimestamp = date;
  };

  const setStart = (newStart: Date | null) => {
    start = newStart;
  };

  const setEnd = (newEnd: Date | null) => {
    end = newEnd;
  };

  const getCurrentTimetstamp = () => currentTimestamp;

  const playAtTimestamp = (dateTime: Date, forcePlay: boolean = false) => {
    if (rewindList === null) {
      return;
    }

    const rewindToPlay = rewindList.find(
      (rewind) => dateTime >= rewind.startDateTime && dateTime <= rewind.endDateTime,
    );

    if (rewindToPlay === undefined) {
      player.pause();
      return;
    }

    const rewindStartPosition = (dateTime.getTime() - rewindToPlay.startDateTime.getTime()) / 1000;

    setCurrentRewind(rewindToPlay);
    playRewindAtPosition({
      player,
      rewind: rewindToPlay,
      positionSeconds: rewindStartPosition,
      forcePlay,
    });
  };

  const playNextRewind = () =>
    attemptToPlayNextRewind({
      player,
      rewindList,
      currentRewind,
      setCurrentRewind,
    });

  const updateCurrentTimestamp = () => {
    if (currentRewind) {
      const currentTimeMilliseconds =
        currentRewind.startDateTime.getTime() + (player.currentTime() as number) * 1000;

      setCurrentTimestamp(new Date(currentTimeMilliseconds));

      if (
        start &&
        end &&
        (currentTimeMilliseconds >= end.getTime() ||
          (currentTimeMilliseconds < start.getTime() && player.readyState() > 0))
      ) {
        player.pause();
        player.trigger('rewindStitcher:rewindListEnded');
      }
    }
  };

  const setRewindList = (newRewinds: RewindVideo[]) => {
    rewindList = orderRewindsByTime(newRewinds);
  };

  player.on('ended', playNextRewind);
  player.on('timeupdate', updateCurrentTimestamp);

  (player as RewindStitcherVideoJsPlayer).rewindStitcherControls = {
    playAtTimestamp,
    setRewindList,
    getCurrentTimetstamp,
    setStart,
    setEnd,
  };
};

export default rewindController;
